<div
  class="presentation-preview-shell tw-w-full tw-h-full"
  resizeObserver
  (resizeEvent)="onResize()"
>
  <div
    #templateEditorPreviewParent
    class="presentation-preview-parent preview-parent embed-responsive"
  >
    <iframe
      #templateEditorPreview
      id="presentation"
      class="presentation-preview embed-responsive-item"
      [class.disable-interaction]="disableInteraction"
      scrolling="no"
      [src]="editorPreviewUrl"
      (load)="onLoad($event)"
    >
    </iframe>
  </div>
</div>
